import React from 'react';

export function RetentionInsightsPage() {
  return (
    <div>
      <h1>Retention Insights</h1>
    </div>
  );
}
